
import { Badge } from "@/components/ui/badge";

interface GprofileLookingForProps {
  lookingFor: string[];
}

const GprofileLookingFor = ({ lookingFor }: GprofileLookingForProps) => {
  const getTagColor = (tag: string) => {
    const colors = {
      'Chat': 'bg-toxic-green/20 text-toxic-green border-toxic-green/30',
      'Friends': 'bg-electric-violet/20 text-electric-violet border-electric-violet/30',
      'Right Now': 'bg-neon-red/20 text-neon-red border-neon-red/30',
      'Relationship': 'bg-purple-500/20 text-purple-300 border-purple-500/30',
      'Dates': 'bg-pink-500/20 text-pink-300 border-pink-500/30',
      'Networking': 'bg-yellow-500/20 text-yellow-300 border-yellow-500/30',
    };
    return colors[tag as keyof typeof colors] || 'bg-ice-white/20 text-ice-white border-ice-white/30';
  };

  return (
    <div className="px-4 py-6 border-b border-ice-white/10">
      <h2 className="text-lg font-semibold text-toxic-green mb-4">Looking For</h2>
      <div className="flex flex-wrap gap-2">
        {lookingFor.map((item, index) => (
          <Badge
            key={index}
            variant="outline"
            className={`px-3 py-2 text-sm font-medium border ${getTagColor(item)}`}
          >
            {item}
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default GprofileLookingFor;
